import { VectorGridOptions } from 'leaflet'

const layersColors: Record<string, string> = {
  cadastralPlots: '#d62a23',
  taxonomicPlots: '#a1b48d',
  I: '#FF3535',
  IIA: '#FF9F1A',
  IIB: '#FFFE56',
  III: '#FF5FFF',
  IV: '#D9FFDC',
  forestHabitats: '#86E4FA',
}

export function getLayerColor(name: string) {
  return layersColors[name] || '#123456'
}

export function buildVectorTileLayerDefaultOptions(
  layerName: string,
  layerSource: string,
  options?: VectorGridOptions
) {
  return {
    vectorTileLayerStyles: {
      [layerSource]: {
        color: getLayerColor(layerName),
        opacity: 0.5,
        fill: true,
        fillColor: getLayerColor(layerName),
        fillOpacity: 0.2,
        weight: 1,
      },
    },
    ...options,
  }
}
